<template>
    <!--@formatter:off-->
    <div>
        <slot
            name="header"
            v-bind:isUseQuestion="isUseQuestion"
            v-bind:setUseQuestion="setUseQuestion"
        ></slot>
        <div v-if="isUseQuestion" class="q_input" :class="{sub_input: isSub}" :id="`questionEditor${questionNo}`">
            <div>
                <slot name="innerHeader"></slot>
                <div class="sub_select" v-if="isSub && !$slots.innerHeader">
                    <span>{{$t('SurveyQuestionEditor_subQuestionOfPrefix', {number: parentQuestionNumber})}}</span>
                    <span class="bx_input_chk" v-for="(answer, index) in parentAnswers">
                        <input type="checkbox" class="input_chk" :id="`parentCondition${questionNo}${answer.answerNo}`" :name="`parentCondition${questionNo}`" :value="answer.answerNo" v-model="parentAnswerCondition">
                        <label :for="`parentCondition${questionNo}${answer.answerNo}`" class="input_lbl">{{$t('common_suffixNumber', {number: index + 1})}}</label>
                    </span>
                    <span>{{$t('SurveyQuestionEditor_subQuestionOfSuffix')}}</span>
                </div>
                <ul>
                    <li>
                        <div class="info_lbl">{{$t('SurveyQuestionEditor_questionNumber', {number: questionNumber})}}</div>
                        <div class="info_txt">
                            <div class="bx_input_wrap">
                                <TextArea
                                    ref="inputQuestion"
                                    :id="`q${questionNo}`"
                                    :placeholder="$t('SurveyQuestionEditor_inputQuestion')"
                                    :maxlength="300"
                                    cols="50"
                                    rows="1"
                                    label-class="input_lbl"
                                    label-tag="label"
                                    :resize="true"
                                    v-model="questionText"
                                />
                                <ul class="b_area">
                                    <li>
                                        <ImageUpload
                                            v-slot="{openFileDialog}"
                                            v-on:requestUpload="uploadImage"
                                            v-ga-helper:click="gaImageUpload"
                                        >
                                            <button
                                                type="button"
                                                class="btn"
                                                @click.prevent="openFileDialog"
                                            >{{$t('SurveyQuestionEditor_attachImage')}}</button>
                                        </ImageUpload>
                                    </li>
                                    <li>
                                    <span class="bx_input_chk bx_chk_req">
                                        <input
                                            type="checkbox"
                                            class="input_chk"
                                            :id="`req${questionNo}`"
                                            v-model="mandatory"
                                            v-ga-helper:change="gaMandatory"
                                        >
                                        <label :for="`req${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_setMandatory')}}</label>
                                    </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="isShowQuestionDesc" class="info_txt">
                            <div class="bx_input_wrap">
                            <TextArea
                                ref="inputQuestionDesc"
                                :id="`q${questionNo}_01`"
                                :placeholder="$t('SurveyQuestionEditor_inputQuestionDesc')"
                                :maxlength="500"
                                cols="50"
                                rows="3"
                                label-class="input_lbl"
                                label-tag="label"
                                :resize="true"
                                v-model="questionDescText"
                            />
                            </div>
                        </div>
                        <div class="bx_include_file" v-if="showImage">
                            <div class="image">
                                <img :src="image.url" alt="" style="max-width: 100%">
                                <button type="button" class="btn_delete" v-on:click.prevent="deleteImage(questionNo)"><span class="sp">{{$t('SurveyQuestionEditor_deleteImage')}}</span></button>
                            </div>
                        </div>
                    </li>
                    <!-- 보기 항목 유형 선택 -->
                    <li v-if="isShowType" class="ex_sel">
                        <div class="info_lbl">{{$t('SurveyQuestionEditor_type')}}</div>
                        <div class="info_select">
                            <span v-if="!showTypes || showTypes.includes('ONE_CHOICE')" class="bx_input_rdo">
                                <input
                                    type="radio"
                                    :name="`a${questionNo}`"
                                    class="input_rdo"
                                    :id="`a1${questionNo}`"
                                    value="ONE_CHOICE"
                                    v-model="type"
                                    v-ga-helper:change="{
                                        view_category: '설문리스트',
                                        view_area: '유형클릭',
                                        view_label: '객관식(단일선택)',
                                    }"
                                >
                                <label :for="`a1${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_singleChoice')}}</label>
                            </span>
                            <span v-if="!showTypes || showTypes.includes('MULTI_CHOICE')" class="bx_input_rdo">
                                <input
                                    type="radio"
                                    :name="`a${questionNo}`"
                                    class="input_rdo"
                                    :id="`a2${questionNo}`"
                                    value="MULTI_CHOICE"
                                    v-model="type"
                                    v-ga-helper:change="{
                                        view_category: '설문리스트',
                                        view_area: '유형클릭',
                                        view_label: '객관식(복수선택)',
                                    }"
                                >
                                <label :for="`a2${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_multipleChoice')}}</label>
                            </span>
                            <span v-if="!showTypes || showTypes.includes('TEXT')" class="bx_input_rdo">
                                <input
                                    type="radio"
                                    :name="`a${questionNo}`"
                                    class="input_rdo"
                                    :id="`a3${questionNo}`"
                                    value="TEXT"
                                    v-model="type"
                                    v-ga-helper:change="{
                                        view_category: '설문리스트',
                                        view_area: '유형클릭',
                                        view_label: '주관식',
                                    }"
                                >
                                <label :for="`a3${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_subjective')}}</label>
                            </span>
                            <span v-if="!isSub && (!showTypes || showTypes.includes('TABLE'))" class="bx_input_rdo">
                                <input
                                    type="radio"
                                    :name="`a${questionNo}`"
                                    class="input_rdo"
                                    :id="`a4${questionNo}`"
                                    value="TABLE"
                                    v-model="type"
                                    v-ga-helper:change="{
                                        view_category: '설문리스트',
                                        view_area: '유형클릭',
                                        view_label: '만족도',
                                    }"
                                >
                                <label :for="`a4${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_satisfaction')}}</label>
                            </span>
                            <span v-if="!showTypes || showTypes.includes('SIGN')" class="bx_input_rdo">
                                <input
                                    type="radio"
                                    :name="`a${questionNo}`"
                                    class="input_rdo"
                                    :id="`a5${questionNo}`"
                                    value="SIGN"
                                    v-model="type"
                                    v-ga-helper:change="{
                                        view_category: '설문리스트',
                                        view_area: '유형클릭',
                                        view_label: '서명',
                                    }"
                                >
                                <label :for="`a5${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_sign')}}</label>
                            </span>
                        </div>
                    </li>

                    <!-- [D] 옵션 영역 -->
                    <li class="ex_sel" v-if="showOptions">
                        <div class="info_lbl">{{$t('common_option')}}</div>
                        <div class="info_select">
                            <ul class="lst_option_area">

                                <!-- [D] 선착순 체크박스  -->
                                <li v-if="showFCFSCheck" class="option_item">
                                <span class="bx_input_chk">
                                    <input
                                        type="checkbox"
                                        class="input_chk type4"
                                        :id="`fcfs-check-${questionNo}`"
                                        v-model="isParentFCFS"
                                        v-ga-helper:change="gaFCFSCheck"
                                    >
                                    <label :for="`fcfs-check-${questionNo}`" class="input_lbl">{{$t('common_fcfs')}}</label>
                                </span>
                                </li>

                                <!-- [D] 객관식(복수선택) 선택수 -->
                                <li class="option_item" v-if="showMaxChoice">
                                    <div class="option_txt">
                                        <i18n path="SurveyQuestionEditor_multiChoice" tag="div">
                                            <template v-slot:dropdown>
                                                <CustomSelect
                                                    class="bx_sorting3"
                                                    :options="select.maxChoice.options"
                                                    :input-props="select.maxChoice.inputProps"
                                                    v-model="maxChoice"
                                                    v-ga-helper:input.vueEvent="gaMaxChoice"
                                                />
                                            </template>
                                        </i18n>
                                    </div>
                                </li>

                                <!-- 만족도 -->
                                <li class="option_item" v-if="showTableColumnLength">
                                    <div class="option_txt">
                                        <CustomSelect
                                            class="bx_sorting3"
                                            :wrapper-class="['satisfied']"
                                            :options="select.tableColumnLength.options"
                                            v-model="tableColumnLength"
                                            v-ga-helper:input.vueEvent="gaSatisfied"
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="ex_sel" v-if="showTableColumnLength">
                        <div class="sub_select">
                            <span>{{$t('SurveyQuestionEditor_satisfactionOfQuestionNumber', {number: questionNumber})}}</span>
                        </div>
                    </li>
                    <template v-if="isChoice">
                        <!-- 질문 입력 항목 -->
                        <template v-for="(answer, index) in answers" v-if="!isTable">
                            <SurveyQuestionAnswerEditor
                                ref="answerEditor"
                                :answer="answer"
                                :question="question"
                                :siblings-count="answers.length"
                                :question-index="questionIndex"
                                :answer-index="index"
                                :is-table="isTable"
                                :is-sub="isSub"
                                :is-parent-f-c-f-s="isParentFCFS"
                                :is-show-image="isShowAnswerImage"
                                :is-show-sub-question="isShowAnswerSubQuestion"
                                @focusPreviousAnswer="focusPreviousAnswer(index)"
                                @focusNextAnswer="focusNextAnswer(index)"
                                @addAnswerOrTableQuestion="addAnswerOrTableQuestion"
                            />
                            <SurveyQuestionAnswerFcfsOptionEditor v-if="isParentFCFS" :question-index="questionIndex" :answer-index="index" />
                        </template>
                        <!-- 질문 추가 -->
                        <!-- [D] 유형: 만족도 선택시에 .satisfied 추가 -->
                        <li class="ex_add">
                            <!-- [D] .full 추가시 100% 넓이로 버튼 사용 -->
                            <button
                                class="btn_add full"
                                type="button"
                                @click.prevent="onClickAddAnswer"
                                v-ga-helper:click="{
                                    view_category: '설문리스트',
                                    view_area: '보기항목추가클릭',
                                    view_label: '',
                                }"
                            >
                              {{$t('SurveyQuestionEditor_addItem')}}
                            </button>
                        </li>
                    </template>
                    <li class="ex ex2" v-if="isText">
                        <div class="info_lbl">{{$t('SurveyQuestionEditor_answer')}}</div>
                        <div class="info_txt">
                            <!-- [D] 글자수로 제어 (답변 입력칸 크기 변화 없음) -->
                            <span class="bx_input bx_textarea">
                            <span class="textarea_info">{{$t('SurveyQuestionEditor_inputTextCount', {count: textLengthValue})}}</span>
                            <textarea cols="50" rows="3" maxlength="150" readonly></textarea>
                        </span>
                        </div>
                    </li>
                    <template v-if="isTable">
                        <template v-for="(question, index) in tableQuestions">
                            <SurveyQuestionAnswerEditor ref="answerEditor" :answer="{}" :question="question" :siblings-count="tableQuestions.length" :question-index="questionIndex" :answer-index="index" :is-table="isTable" :is-sub="isSub"  @focusPreviousAnswer="focusPreviousAnswer(index)" @focusNextAnswer="focusNextAnswer(index)" @addAnswerOrTableQuestion="addAnswerOrTableQuestion" />
                        </template>
                        <li class="ex_add satisfied">
                            <!-- [D] .full 추가시 100% 넓이로 버튼 사용 -->
                            <button class="btn_add full" type="button" @click.prevent="addTableQuestion">{{$t('SurveyQuestionEditor_addItem')}}</button>
                        </li>
                    </template>
                    <template v-if="isSign">
                        <li class="ex">
                            <div class="info_lbl">{{$t('SurveyQuestionEditor_signArea')}}</div>
                            <div class="info_txt">
                                <div class="bx_sign_editor">
                                    <div class="in">
                                        <span class="img_sign"><img src="@iamteacherpc/assets/iamteacher/editor/img/img_survey_sign.png" alt=""></span>
                                        <p class="txt_sign">{{$t('SurveyQuestionEditor_signHere')}}</p>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
                <div v-if="isShowOperation" class="btn_txt">
                    <template v-if="isSub">
                        <button type="button" v-if="showDelete" @click.prevent="deleteQuestion">{{$t('SurveyQuestionEditor_deleteSubQuestion')}}</button>
                    </template>
                    <template v-else>
                        <button
                            type="button"
                            @click.prevent="copyQuestion"
                            v-ga-helper:click="{
                                view_category: '설문리스트',
                                view_area: '질문복사하기클릭',
                                view_label: '',
                            }"
                        >
                          {{$t('SurveyQuestionEditor_copy')}}
                        </button>
                        <button
                            v-if="showDelete"
                            type="button"
                            @click.prevent="deleteQuestion"
                            v-ga-helper:click="{
                                view_category: '설문리스트',
                                view_area: '질문삭제하기클릭',
                                view_label: '',
                            }"
                        >
                          {{$t('SurveyQuestionEditor_delete')}}
                        </button>
                    </template>
                </div>
            </div>
        </div>
        <template v-for="(q, index) in questions" v-if="showSubQuestion">
            <SurveyQuestionEditor :question="q" :question-index="index" :siblings-count="questions.length" :parent-question-number="questionNumber" :key="q.questionNo"/>
        </template>
    </div>
    <!--@formatter:on-->
</template>

<script>
import TextArea from '@iamteacherpc/components/common/TextArea.vue';
import {
    ADD_ANSWER,
    ADD_SUB_QUESTION,
    COPY_QUESTION,
    DELETE_QUESTION,
    DELETE_QUESTION_IMAGE,
    GET_START_QUESTION_NUMBER,
    MAX_ANSWER,
    MAX_SUB_QUESTION,
    NAMESPACE,
    UPLOAD_QUESTION_IMAGE,
} from '@common/store/modules/survey/editor.js';
import {requestAlert, requestConfirm} from '@iamteacherpc/utils/iframe.js';
import {createNamespacedHelpers} from 'vuex';
import ImageUpload from '@iamteacherpc/components/common/ImageUpload.vue';
import {REQUEST_STATE} from '@iamteacherpc/consts/request.js';
import {ANSWER_TYPE, TEXT_LENGTH_VALUE} from '@/common/consts/survey.js';
import CustomSelect from '@iamteacherpc/components/common/CustomSelect.vue';
import SurveyQuestionAnswerEditor from '@iamteacherpc/components/editor/SurveyQuestionAnswerEditor.vue';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@common/store/modules/common/editor/questionList.js';
import {
    SET_QUESTION_MANDATORY,
    SET_QUESTION_MAX_CHOICE,
    SET_QUESTION_PARENT_ANSWER_CONDITION,
    SET_QUESTION_PARENT_FCFS,
    SET_QUESTION_QUESTION,
    SET_QUESTION_QUESTION_DESC,
    SET_QUESTION_TABLE_COLUMN_LENGTH,
    SET_QUESTION_TYPE,
    SET_QUESTION_USE_QUESTION,
} from '@common/store/modules/common/editor/question.js';
import SurveyQuestionAnswerFcfsOptionEditor
    from '@iamteacherpc/components/editor/SurveyQuestionAnswerFcfsOptionEditor.vue';
import ACCEPTED_DOMAIN from "@common/consts/accepted-domain";

const {mapGetters, mapActions} = createNamespacedHelpers(NAMESPACE);
    export default {
        name: 'SurveyQuestionEditor',
        components: {
            SurveyQuestionAnswerEditor,
            SurveyQuestionAnswerFcfsOptionEditor,
            CustomSelect,
            ImageUpload,
            TextArea,
        },

        props: {
            question: {
                type: Object,
                required: true,
            },
            isUseStartQuestionNumber: {
                type: Boolean,
                default: true,
            },
            questionIndex: {
                type: Number,
                required: true,
            },
            siblingsCount: {
                type: Number,
                required: true,
            },
            parentQuestionNumber: {
                type: String,
            },
            isShowQuestionDesc: {
                type: Boolean,
                default: true,
            },
            isShowType: {
                type: Boolean,
                default: true,
            },
            showTypes: {
                type: Array,
            },
            isShowOptions: {
                type: Boolean,
                default: true,
            },
            isShowAnswerImage: {
                type: Boolean,
                default: true,
            },
            isShowAnswerSubQuestion: {
                type: Boolean,
                default: true,
            },
            isShowOperation: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                select: {
                    maxChoice: {
                        options: [
                            {label: this.$t('common_noLimit'), value: 0},
                            {label: '2', value: 2},
                            {label: '3', value: 3},
                            {label: '4', value: 4},
                            {label: '5', value: 5},
                            {label: this.$t('common_inputBySelf'), value: '__INPUT__'}
                        ],
                        inputProps: {
                            id: `max-choice${this.questionIndex}`,
                            onlyNumber: true,
                            maxLength: 3,
                            placeholder: this.$t('common_inputBySelf')
                        }
                    },
                    tableColumnLength: {
                        options: [
                            {label: this.$t('SurveyQuestionEditor_satisfyStep5'), value: 5},
                            {label: this.$t('SurveyQuestionEditor_satisfyStep4'), value: 4},
                            {label: this.$t('SurveyQuestionEditor_satisfyStep3'), value: 3},
                        ],
                    },
                },
            }
        },

        watch: {
            type(newValue) {
                if (newValue === ANSWER_TYPE.TABLE && this.tableQuestions.length < 1) {
                    this.addTableQuestion();
                }
            }
        },

        computed: {
            ...mapGetters([
                GET_START_QUESTION_NUMBER,
            ]),

            isUseQuestion: {
                get() {
                    return this.question.isUseQuestion;
                },
                set(newValue) {
                    this.storeSetUseQuestion({question: this.question, isUseQuestion: newValue});
                },
            },

            parentAnswerCondition: {
                get() {
                    return this.question.parentAnswerCondition;
                },
                set(newValue) {
                    this.storeSetParentAnswerCondition({question: this.question, parentAnswerCondition: newValue});
                },
            },

            questionText: {
                get() {
                    return this.question.question;
                },
                set(newValue) {
                    this.storeSetQuestion({question: this.question, text: newValue});
                }
            },

            questionDescText: {
                get() {
                    return this.question.questionDesc;
                },
                set(newValue) {
                    this.storeSetQuestionDesc({question: this.question, text: newValue});
                }
            },

            mandatory: {
                get() {
                    return this.question.mandatory;
                },
                set(newValue) {
                    this.storeSetMandatory({question: this.question, mandatory: newValue});
                }
            },

            type: {
                get() {
                    return this.question.type;
                },
                set(newValue) {
                    this.storeSetType({question: this.question, type: newValue});
                }
            },

            maxChoice: {
                get() {
                    return this.question.maxChoice;
                },
                set(newValue) {
                    this.storeSetMaxChoice({question: this.question, maxChoice: newValue});
                }
            },

            tableColumnLength: {
                get() {
                    return this.question.tableColumnLength;
                },
                set(newValue) {
                    this.storeSetTableColumnLength({question: this.question, tableColumnLength: newValue});
                },
            },

            isParentFCFS: {
                get() {
                    return this.question.isParentFCFS;
                },
                set(newValue) {
                    this.storeSetParentFCFS({question: this.question, isParentFCFS: newValue});
                },
            },

            questionNo() {
                return this.question.questionNo;
            },

            image() {
                return this.question.image;
            },

            questionNumber() {
                let number = '';

                if (this.isSub) {
                    number += this.parentQuestionNumber + '-';
                }

                let questionIndex = this.questionIndex;
                if (this.isUseStartQuestionNumber && !this.isSub) {
                    questionIndex += this[GET_START_QUESTION_NUMBER];
                } else {
                    questionIndex += 1;
                }

                return number + questionIndex;
            },

            showImage() {
                return this.image && this.image.uploadState === REQUEST_STATE.SUCCESS;
            },

            showOptions() {
                return this.isShowOptions && (this.showFCFSCheck || this.showMaxChoice || this.showTableColumnLength);
            },

            showFCFSCheck() {
                return this.isChoice && !this.isSub;
            },

            showMaxChoice() {
                return this.type === ANSWER_TYPE.MULTI_CHOICE;
            },

            showTableColumnLength() {
                return this.isTable;
            },

            showDelete() {
                return this.question.parentQuestion || this.siblingsCount > 1;
            },

            isSign() {
                return this.type === ANSWER_TYPE.SIGN;
            },

            isTable() {
                return this.type === ANSWER_TYPE.TABLE;
            },

            isChoice() {
                return this.type === ANSWER_TYPE.ONE_CHOICE || this.type === ANSWER_TYPE.MULTI_CHOICE;
            },

            showSubQuestion() {
                return !this.isSub && this.isChoice && !this.isParentFCFS;
            },

            isText() {
                return this.type === ANSWER_TYPE.TEXT;
            },

            textLengthValue() {
                return TEXT_LENGTH_VALUE[this.question.textLength];
            },

            answers() {
                return this.question.answers;
            },

            questions() {
                return this.question.questions;
            },

            tableQuestions() {
                return this.question.tableQuestions;
            },

            isSub() {
                return !!this.question.parentQuestion;
            },

            parentAnswers() {
                return this.question.parentQuestion.answers;
            }
        },

        methods: {
            ...mapActions({
                storeSetParentAnswerCondition: SET_QUESTION_PARENT_ANSWER_CONDITION,
                storeSetUseQuestion: SET_QUESTION_USE_QUESTION,
                storeSetQuestion: SET_QUESTION_QUESTION,
                storeSetQuestionDesc: SET_QUESTION_QUESTION_DESC,
                storeUploadImage: UPLOAD_QUESTION_IMAGE,
                storeDeleteImage: DELETE_QUESTION_IMAGE,
                storeSetMandatory: SET_QUESTION_MANDATORY,
                storeSetType: SET_QUESTION_TYPE,
                storeSetMaxChoice: SET_QUESTION_MAX_CHOICE,
                storeSetTableColumnLength: SET_QUESTION_TABLE_COLUMN_LENGTH,
                storeSetParentFCFS: SET_QUESTION_PARENT_FCFS,
                storeAddAnswer: ADD_ANSWER,
                storeAddSubQuestion: ADD_SUB_QUESTION,
                storeCopyQuestion: COPY_QUESTION,
                storeDeleteQuestion: DELETE_QUESTION,
                stopListChange: STOP_LIST_CHANGE,
                listChange: LIST_CHANGE,
            }),

            // slot prop으로 setter가 있는 computed 값을 전달하고
            // 상위 컴포넌트에서 값을 재할당하여도 setter가 호출되지 않는다.
            // 별도의 set 함수를 만들어 전달한다.
            setUseQuestion(isUseQuestion) {
                this.isUseQuestion = isUseQuestion;
            },

            focusQuestion() {
                this.$refs.inputQuestion.focus();
            },

            uploadImage(file) {
                this.storeUploadImage({
                    question: this.question,
                    file: file,
                }).catch(e => {
                    requestAlert({title: e.message, okText: this.$t('common_confirm')});
                });
            },

            deleteImage() {
                this.storeDeleteImage({question: this.question});
            },

            onClickAddAnswer(){
                this.addAnswer();
                // postMessage 먼저 보낼 때
                ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                    window.parent.postMessage(
                        {
                          type: 'OPEN_SPOTGUIDE',
                          data: {
                            areaId: 'SURVEY_ANSWER_ADD',
                          }
                        },
                        origin,
                    );
                })
            },

            addAnswer() {
                if (this.answers.length === MAX_ANSWER) {
                    this.stopListChange();

                    requestAlert({
                        title: this.$t('SurveyQuestionEditor_maxExample', {max: MAX_ANSWER}),
                        okText: this.$t('common_confirm')
                    }).then(() => this.listChange());

                    return;
                }

                this.storeAddAnswer({question: this.question});

                this.$nextTick(function () {
                    this.focusAnswer(this.answers.length - 1);
                });
            },

            addTableQuestion() {
                if (this.tableQuestions.length >= MAX_SUB_QUESTION) {
                    this.stopListChange();

                    requestAlert({
                        title: this.$t('SurveyQuestionEditor_maxSatisfyQuestion', {max: MAX_SUB_QUESTION}),
                        okText: this.$t('common_confirm')
                    }).then(() => this.listChange());

                    return;
                }

                this.storeAddSubQuestion({question: this.question, answerNo: undefined});

                this.$nextTick(function () {
                    this.focusAnswer(this.tableQuestions.length - 1);
                });
            },

            copyQuestion() {
                this.storeCopyQuestion({question: this.question});
                this.$emit('copyQuestion');
            },

            deleteQuestion() {
                this.stopListChange();

                requestConfirm({
                    title: this.$t('SurveyQuestionEditor_confirmDeleteQuestion'),
                    okText: this.$t('common_confirm'),
                    cancelText: this.$t('common_cancel')
                }).then(() => {
                    this.storeDeleteQuestion({question: this.question});
                }).catch(() => {
                    // do nothing
                }).finally(() => {
                    this.listChange();
                });
            },

            focusAnswer(index) {
                if (this.isTable || this.isChoice) {
                    this.$refs.answerEditor[index].focusAnswer();
                }
            },

            focusPreviousAnswer(index) {
                let count;

                if (this.isChoice) {
                    count = this.answers.length;
                } else {
                    count = this.questions.length;
                }

                if (index > 0) {
                    this.focusAnswer(index - 1);
                }
            },

            focusNextAnswer(index) {
                let count;

                if (this.isChoice) {
                    count = this.answers.length;
                } else if (this.isTable) {
                    count = this.tableQuestions.length;
                } else {
                    count = this.questions.length;
                }

                if (index < count - 1) {
                    this.focusAnswer(index + 1);
                }
            },

            addAnswerOrTableQuestion() {
                if (this.isChoice) {
                    this.addAnswer();
                    return;
                }
                this.addTableQuestion();
            },

            gaImageUpload() {
                // surveyEditor
                return {
                    view_category: '설문리스트',
                    view_area: '질문이미지첨부클릭',
                    view_label: '',
                }
            },

            gaMandatory($event) {
                return {
                    view_category: '설문리스트',
                    view_area: `필수질문설정클릭${$event.target.checked ? '' : '해제'}`,
                    view_label: '',
                }
            },

            gaFCFSCheck($event) {
                return {
                    view_category: '설문리스트',
                    view_area: `선착순옵션클릭${$event.target.checked ? '' : '해제'}`,
                    view_label: '',
                }
            },

            gaMaxChoice($event) {
                const selectedItem = this.select.maxChoice.options.find(v => v.value === $event);
                return {
                    view_category: '설문리스트',
                    view_area: '복수선택개수클릭',
                    view_label: selectedItem ? selectedItem.label : '직접입력',
                }
            },

            gaSatisfied($event) {
                const selectedItem = this.select.tableColumnLength.options.find(option => option.value === $event);
                return {
                    view_category: '설문리스트',
                    view_area: '만족도옵션클릭',
                    view_label: selectedItem ? selectedItem.label.replace(/(\s*)/g, '') : '직접입력',
                }
            },
        },
    }
</script>

<style scoped>

</style>
